import BezierEasing from 'bezier-easing';

export const ENTER = 'enter';
export const EXIT = 'exit';

export const EASING = {
    easeIn: BezierEasing(0, 0.7, 0, 1),
    easeOut: BezierEasing(0, 0, 1, 0.3),
    easeInOut: BezierEasing(0.75, 0, 0.25, 1),
    linear: BezierEasing(0, 0, 1, 1),
} as const;

export const DURATION = {
    fast1: 0.07 * 1000,
    fast2: 0.1 * 1000,
    fast3: 0.12 * 1000,
    moderate1: 0.2 * 1000,
    moderate2: 0.25 * 1000,
    moderate3: 0.3 * 1000,
    slow1: 0.37 * 1000,
    slow2: 0.4 * 1000,
    slow3: 0.5 * 1000,
} as const;

export const SLIDE_FADE_OFFSETS = {
    none: 0,
    sm: 8,
    md: 16,
    lg: 32,
} as const;
